import { styled } from '@mui/material';

export const StyledSVG = styled('svg')``;
